// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultKPIPropsDefinedSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import {
  createDropDownSchema,
  createPopupSettingSchema,
  createNumberSchema
} from 'share/utils/Izenda.PropsEditorGuiSchemaFunctions';

import { getAll } from 'share/factories/Izenda.ReportPartStyleFactories';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';

import localizer from 'share/localization/Izenda.Localizer';

import ChartDataRefreshSettings
  from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.DataRefreshSetting';
import ReportPartBackgroundImage from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartBackgroundImage';

const getChartTypeOptions = () =>
  getAll(REPORT_PART_TYPE.KPI).map(({ label, style, previewCSS }) => ({
    label,
    value: style,
    className: previewCSS
  }));

/**
 * The common chart properties GUI schema that shares to all gauge type.
 */
export default {
  schemaKey: 'RP_GAUGE_TYPE',
  groups: {
    generalInfo: {
      title: () => localizer.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GENERAL_INFO'),
      fields: {
        chartType: {
          factory: createDropDownSchema,
          title: () => localizer.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GAUGE_TYPE'),
          value: 'getChartType',
          props: {
            get options() {
              return getChartTypeOptions();
            }
          }
        }
      }
    },
    kpi: {
      title: 'KPI',
      fields: {
        backgroundImage: {
          factory: createPopupSettingSchema,
          title: 'Background Image',
          value: 'getValueByKey',
          props: {
            fnResetDefaultValue: 'resetBackgroundImageProp',
            hadSetting: 'isBackgroundImageSet',
            height: 'getReportPartHeight',
            width: 'getReportPartWidth'
          },
          staticProps: {
            get popupTitle() {
              return 'KPI Background Image'
            },
            popupContent: ReportPartBackgroundImage
          }
        }
      }
    },
    view: {
      title: () => localizer.getText('MODEL_LABEL_VIEW'),
      fields: {
        numRows: {
          factory: createNumberSchema,
          title: localizer.getText('REPORT_PART_PROPS_KPI_ROWS'),
          value: 'getValueByKey',
          props: {
            min: 'getMinRows',
            isDecimal: false
          }
        },
        numCols: {
          factory: createNumberSchema,
          title: localizer.getText('REPORT_PART_PROPS_KPI_COLS'),
          value: 'getValueByKey',
          props: {
            min: 'getMinCols',
            isDecimal: false
          }
        },
        cellSize: {
          factory: createNumberSchema,
          title: localizer.getText('REPORT_PART_PROPS_KPI_CELL_SIZE'),
          value: 'getValueByKey',
          props: {
            min: 15,
            isDecimal: false
          }
        },
        dataRefreshInterval: {
          factory: createPopupSettingSchema,
          title: () => localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING'),
          isHidden: 'isNotBuild',
          value: 'getValueByKey',
          props: {
            get reportPartType() {
              return REPORT_PART_TYPE.KPI;
            },
            get title() {
              return localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            hadSetting: 'hadSettingRefreshInterval',
            fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
            hiddenByState: true,
            loadValue: 'getSettingRefreshInterval'
          },
          staticProps: {
            get popupTitle() {
              return localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            popupContent: ChartDataRefreshSettings,
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.DefaultKPIPropsDefinedSchema.js